import React from "react";
import { Link } from "react-router-dom";
import Wordmark from "./Wordmark";

export default function Footer() {
  return (
    <footer className="mt-24 bg-foreground text-background" data-testid="site-footer">
      <div className="container-tight py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <Wordmark size="lg" dark />
          <p className="mt-6 max-w-md text-sm text-background/70 leading-relaxed">
            A funding platform for golfers to raise the money they need for their sporting endeavours, connecting
            supporters and sponsors directly with the golfers they want to back.
          </p>
        </div>

        <div>
          <div className="overline text-background/60">Explore</div>
          <ul className="space-y-2 text-sm mt-4">
            <li><Link to="/golfers" className="hover:text-secondary">Golfers</Link></li>
            <li><Link to="/sponsors" className="hover:text-secondary">Sponsorship tiers</Link></li>
            <li><Link to="/apply" className="hover:text-secondary">Apply for funding</Link></li>
            <li><Link to="/about" className="hover:text-secondary">About TGI</Link></li>
            <li><Link to="/brand" className="hover:text-secondary">Brand & press kit</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline text-background/60">Contact</div>
          <ul className="space-y-2 text-sm text-background/70 mt-4">
            <li><a href="mailto:golfersfund@talkgolfireland.com" className="hover:text-secondary">golfersfund@talkgolfireland.com</a></li>
            <li><a href="tel:+353874257257" className="hover:text-secondary">+353 87 425 7257</a></li>
            <li>Dublin, Ireland</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background/15">
        <div className="container-tight py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-background/50">
          <div>© {new Date().getFullYear()} Talk Golf International. All rights reserved.</div>
          <div className="flex gap-6">
            <Link to="/brand" className="hover:text-background">Brand kit</Link>
            <Link to="/cookies" className="hover:text-background">Cookies</Link>
            <Link to="/privacy" className="hover:text-background">Privacy</Link>
            <Link to="/terms" className="hover:text-background">Terms</Link>
            <a href="#" className="hover:text-background">Press</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
